import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AuthService } from "../../../auth.service";
import { NavigationHelper } from "../../../services/navigation.helper";

@Component({
  selector: "app-list-header",
  templateUrl: "./list-header.component.html",
  styleUrls: ["./list-header.component.css"],
})
export class ListHeaderComponent {
  @Input() title: BehaviorSubject<string> = new BehaviorSubject<string>("");

  @Input() searchPlaceholder = "";
  @Input() searchTerm: string | null = "";
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<void>();
  @Output() addNewItem = new EventEmitter<void>();

  /**
   * Set when the list is open to pick a value for a field. Closing goes back
   * to where the list was opened from: leaving the choose url is what ends a
   * choice (#179). Not by the back button's route, which can end up in the
   * browser history and closes the Android app (#184).
   */
  @Input() closable = false;

  /** Off for a short fixed list, like the bulk actions: nothing to search, nothing to add. */
  @Input() searchable = true;
  @Input() addable = true;

  supervisor: boolean = false;
  constructor(private auth: AuthService, private nav: NavigationHelper) {}
  ngOnInit() {
    if (!this.title.getValue()) {
      this.title.next("");
    }
    if (!this.searchPlaceholder) {
      this.searchPlaceholder = "";
    }
    this.supervisor = this.auth.isSupervisor();
  }

  onSearchChange(value: string): void {
    this.searchTermChange.emit(value);
  }

  onClearSearch(): void {
    this.clearSearch.emit();
  }

  onAddNewItem(): void {
    this.addNewItem.emit();
  }

  onClose(): void {
    this.nav.closeChoice();
  }
  get isSupervisor(): boolean {
    return this.auth.userdata.supervisor;
  }
}
